/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Alert } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { FC } from 'react';

interface OrderPresenceBannerProps {
  ownerName: string;
  show: boolean;
}

const bannerStyles = css`
  margin-bottom: 16px;
  
  .MuiAlert-icon {
    align-items: center;
  }
  
  .MuiAlert-message {
    font-size: 14px;
    font-weight: 500;
  }
`;

export const OrderPresenceBanner: FC<OrderPresenceBannerProps> = ({
  ownerName,
  show,
}) => {
  if (!show) {
    return null;
  }

  return (
    <Alert
      severity="info"
      icon={<InfoIcon />}
      css={bannerStyles}
    >
      <strong>{ownerName}</strong> is already working on this order
    </Alert>
  );
};

export default OrderPresenceBanner;
